import { TagsGrid } from "@brg/ui";
import { FC, HTMLAttributes, RefObject } from "react";

export interface IBTagsGridNewProps extends HTMLAttributes<HTMLDivElement> {
  scrollMode?: 'all' | 'desktop_only' | 'none'
  justify?: 'flex-start' | 'center' | 'flex-end'
  shadow?: Boolean
  customShadowColor?: string
  noLimitMaxHeight?: Boolean
  ref?: RefObject<HTMLDivElement>;

}

export const BTagsGridNew: FC<IBTagsGridNewProps> = (props) => {
  // @ts-ignore
  return <TagsGrid {...props} scrollMode={props.scrollMode || 'desktop_only'} />
}import { TagsGrid } from "@brg/ui";
import { FC, HTMLAttributes, RefObject } from "react";

export interface IBTagsGridNewProps extends HTMLAttributes<HTMLDivElement> {
  scrollMode?: 'all' | 'desktop_only' | 'none'
  justify?: 'flex-start' | 'center' | 'flex-end'
  shadow?: Boolean
  customShadowColor?: string
  noLimitMaxHeight?: Boolean
  ref?: RefObject<HTMLDivElement>;

}

export const BTagsGridNew: FC<IBTagsGridNewProps> = (props) => {
  // @ts-ignore
  return <TagsGrid {...props} scrollMode={props.scrollMode || 'desktop_only'} />
}